import {createContext, useContext, useEffect} from 'react'

export const LegacyModalContext = createContext({})
export const LegacyModalProvider = LegacyModalContext.Provider

export const useLegacyModalContext = () => useContext(LegacyModalContext)

export const useSetLegacyModalPropsRaw = (data, watch = []) => {
	const {setModalPropsRaw} = useLegacyModalContext()
	useEffect(() => {
		setModalPropsRaw(data)
	}, watch)
}
